import { render, staticRenderFns } from "./OverlayCard.vue?vue&type=template&id=ccfba6e6&scoped=true"
import script from "./OverlayCard.vue?vue&type=script&lang=js"
export * from "./OverlayCard.vue?vue&type=script&lang=js"
import style0 from "./OverlayCard.vue?vue&type=style&index=0&id=ccfba6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfba6e6",
  null
  
)

export default component.exports